(function () {
  var root = typeof window !== 'undefined' ? window : globalThis;

  var C = {
    EDITOR_SPREAD_W: 800,
    EDITOR_SPREAD_H: 566,
    EDITOR_PAGE_W: 400,
    EDITOR_PAGE_H: 566,
    TRIM_W_MM: 210,
    TRIM_H_MM: 297,
    BLEED_MM: 3,
    MEDIA_W_MM: 216,
    MEDIA_H_MM: 303
  };

  function round(value) {
    return Math.round(Number(value || 0) * 10000) / 10000;
  }

  function clone(value) {
    return JSON.parse(JSON.stringify(value || {}));
  }

  function sideOffset(side) {
    return side === 'right' ? C.EDITOR_PAGE_W : 0;
  }

  function mapPointToPageMm(x, y, side) {
    var localX = Number(x || 0) - sideOffset(side);
    return {
      x: round(C.BLEED_MM + (localX / C.EDITOR_PAGE_W) * C.TRIM_W_MM),
      y: round(C.BLEED_MM + (Number(y || 0) / C.EDITOR_PAGE_H) * C.TRIM_H_MM)
    };
  }

  function objectBoundsPx(obj) {
    var w = Number(obj.width || 0) * Number(obj.scaleX || 1);
    var h = Number(obj.height || 0) * Number(obj.scaleY || 1);
    var centerX = Number(obj.left || 0);
    var centerY = Number(obj.top || 0);
    var angle = (Number(obj.angle || 0) * Math.PI) / 180;
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var halfW = w / 2;
    var halfH = h / 2;
    var corners = [
      { x: -halfW, y: -halfH },
      { x: halfW, y: -halfH },
      { x: halfW, y: halfH },
      { x: -halfW, y: halfH }
    ].map(function (point) {
      return {
        x: centerX + point.x * cos - point.y * sin,
        y: centerY + point.x * sin + point.y * cos
      };
    });
    var left = Math.min.apply(null, corners.map(function (point) { return point.x; }));
    var top = Math.min.apply(null, corners.map(function (point) { return point.y; }));
    var right = Math.max.apply(null, corners.map(function (point) { return point.x; }));
    var bottom = Math.max.apply(null, corners.map(function (point) { return point.y; }));
    return {
      left: round(left),
      top: round(top),
      right: round(right),
      bottom: round(bottom),
      width: round(right - left),
      height: round(bottom - top)
    };
  }

  function intersectsPage(bounds, side) {
    var pageLeft = sideOffset(side);
    var pageRight = pageLeft + C.EDITOR_PAGE_W;
    return bounds.right > pageLeft && bounds.left < pageRight && bounds.bottom > 0 && bounds.top < C.EDITOR_PAGE_H;
  }

  function clippedBounds(bounds, side) {
    var pageLeft = sideOffset(side);
    var pageRight = pageLeft + C.EDITOR_PAGE_W;
    return {
      left: Math.max(bounds.left, pageLeft),
      top: Math.max(bounds.top, 0),
      right: Math.min(bounds.right, pageRight),
      bottom: Math.min(bounds.bottom, C.EDITOR_PAGE_H)
    };
  }

  function boundsToBoxMm(bounds, side) {
    var tl = mapPointToPageMm(bounds.left, bounds.top, side);
    var br = mapPointToPageMm(bounds.right, bounds.bottom, side);
    return {
      x: tl.x,
      y: tl.y,
      width: round(br.x - tl.x),
      height: round(br.y - tl.y)
    };
  }

  function manifestMap(manifest) {
    var map = {};
    var photos = manifest && Array.isArray(manifest.photos) ? manifest.photos : [];
    photos.forEach(function (photo) {
      if (photo && photo.photoId) map[photo.photoId] = photo;
    });
    return map;
  }

  function rawExtensionFromName(name) {
    var match = String(name || '').match(/\.([A-Za-z0-9]+)$/);
    if (!match) return 'jpg';
    var ext = match[1].toLowerCase();
    return ext === 'jpeg' ? 'jpg' : ext;
  }

  function inferRawPath(storageFolder, photoId, existingPath, filename) {
    if (existingPath) return existingPath;
    if (!storageFolder || !photoId) return '';
    return storageFolder + '/raw/' + photoId + '/original.' + rawExtensionFromName(filename);
  }

  function visibleSourceCropPx(obj, bounds, clipped) {
    var baseX = Number(obj.cropX || 0);
    var baseY = Number(obj.cropY || 0);
    var sourceW = Number(obj.width || 0);
    var sourceH = Number(obj.height || 0);
    if (!sourceW || !sourceH || Number(obj.angle || 0) % 360 !== 0) {
      return {
        x: round(baseX),
        y: round(baseY),
        width: round(sourceW),
        height: round(sourceH)
      };
    }
    var drawnW = bounds.right - bounds.left;
    var drawnH = bounds.bottom - bounds.top;
    if (!drawnW || !drawnH) {
      return { x: round(baseX), y: round(baseY), width: 0, height: 0 };
    }
    return {
      x: round(baseX + ((clipped.left - bounds.left) / drawnW) * sourceW),
      y: round(baseY + ((clipped.top - bounds.top) / drawnH) * sourceH),
      width: round(((clipped.right - clipped.left) / drawnW) * sourceW),
      height: round(((clipped.bottom - clipped.top) / drawnH) * sourceH)
    };
  }

  function imagePrintObject(obj, bounds, clipped, side, sourceIndex, photo, storageFolder) {
    var photoId = obj.photoId || (photo && photo.photoId) || '';
    var rawPath = obj.rawPath || obj.sourcePath || obj.printPath || (photo && (photo.rawPath || photo.sourcePath || photo.printPath)) || '';
    rawPath = inferRawPath(storageFolder, photoId, rawPath, obj.filename || obj.name || (photo && (photo.filename || photo.name)));
    var previewPath = obj.highresPath || obj.previewPath || (photo && (photo.highresPath || photo.previewPath)) || '';
    var thumbPath = obj.thumbPath || obj.customThumbSrc || (photo && photo.thumbPath) || '';
    return {
      type: 'image',
      sourceObjectIndex: sourceIndex,
      photoId: photoId,
      rawPath: rawPath,
      sourcePath: obj.sourcePath || rawPath,
      printPath: obj.printPath || rawPath,
      previewPath: previewPath,
      thumbPath: thumbPath,
      boxMm: boundsToBoxMm(clipped, side),
      sourceCropPx: visibleSourceCropPx(obj, bounds, clipped),
      sourceCropPxMode: Number(obj.angle || 0) % 360 === 0 ? 'visible-crop' : 'full-object-transform',
      rotation: round(obj.angle || 0),
      opacity: obj.opacity == null ? 1 : Number(obj.opacity),
      clip: {
        side: side,
        sourceBoundsPx: clone(clipped),
        sourceObjectBoundsPx: clone(bounds),
        requiresTransformClip: Number(obj.angle || 0) % 360 !== 0
      },
      fabric: clone(obj)
    };
  }

  function genericPrintObject(obj, clipped, side, sourceIndex) {
    return {
      type: obj.type || 'object',
      sourceObjectIndex: sourceIndex,
      boxMm: boundsToBoxMm(clipped, side),
      rotation: round(obj.angle || 0),
      opacity: obj.opacity == null ? 1 : Number(obj.opacity),
      text: obj.text || '',
      fill: obj.fill || '',
      stroke: obj.stroke || '',
      fontFamily: obj.fontFamily || '',
      fontSize: obj.fontSize || '',
      fontWeight: obj.fontWeight || '',
      fontStyle: obj.fontStyle || '',
      textAlign: obj.textAlign || '',
      lineHeight: obj.lineHeight || '',
      charSpacing: obj.charSpacing || '',
      clip: { side: side, sourceBoundsPx: clone(clipped) },
      fabric: clone(obj)
    };
  }

  var MIN_VISIBLE_PX = 2;

  function convertObject(obj, side, sourceIndex, photoById, storageFolder) {
    var bounds = objectBoundsPx(obj);
    if (!intersectsPage(bounds, side)) return null;
    var clipped = clippedBounds(bounds, side);
    if ((clipped.right - clipped.left) < MIN_VISIBLE_PX || (clipped.bottom - clipped.top) < MIN_VISIBLE_PX) return null;
    var photo = obj.photoId ? photoById[obj.photoId] : null;
    if (obj.type === 'image' || obj.customUrl || obj.customThumbSrc || obj.src) {
      return imagePrintObject(obj, bounds, clipped, side, sourceIndex, photo, storageFolder);
    }
    return genericPrintObject(obj, clipped, side, sourceIndex);
  }

  function buildPage(spread, spreadIndex, side, pageIndex, photoById, storageFolder) {
    var objects = [];
    (spread.objects || []).forEach(function (obj, index) {
      if (!obj || obj.isPaper || obj.isPlaceholder || obj._isCropRect) return;
      var converted = convertObject(obj, side, index, photoById, storageFolder);
      if (converted) objects.push(converted);
    });
    return {
      pageIndex: pageIndex,
      spreadIndex: spreadIndex,
      side: side,
      sourceClipPx: { x: sideOffset(side), y: 0, width: C.EDITOR_PAGE_W, height: C.EDITOR_PAGE_H },
      mediaBoxMm: { width: C.MEDIA_W_MM, height: C.MEDIA_H_MM },
      trimBoxMm: { x: C.BLEED_MM, y: C.BLEED_MM, width: C.TRIM_W_MM, height: C.TRIM_H_MM },
      paperColor: spread.paperColor || '#ffffff',
      objects: objects
    };
  }

  function buildPrintBlueprint(options) {
    options = options || {};
    var spreadMemory = Array.isArray(options.spreadMemory) ? options.spreadMemory : [];
    var photoById = manifestMap(options.photoManifest);
    var pages = [];
    spreadMemory.forEach(function (spread, spreadIndex) {
      pages.push(buildPage(spread || {}, spreadIndex, 'left', pages.length + 1, photoById, options.storageFolder || ''));
      pages.push(buildPage(spread || {}, spreadIndex, 'right', pages.length + 1, photoById, options.storageFolder || ''));
    });
    return {
      version: 1,
      bookId: options.bookId || '',
      title: options.title || '',
      year: options.year || '',
      storageFolder: options.storageFolder || '',
      coverTemplateKey: options.coverTemplateKey || '',
      bookType: options.bookType || '',
      destinationCountry: options.destinationCountry || '',
      unit: 'mm',
      createdAt: new Date().toISOString(),
      source: {
        layoutBlueprintPath: options.layoutBlueprintPath || '',
        photoManifestPath: options.photoManifestPath || '',
        editorSpreadSize: { width: C.EDITOR_SPREAD_W, height: C.EDITOR_SPREAD_H },
        editorPageSize: { width: C.EDITOR_PAGE_W, height: C.EDITOR_PAGE_H }
      },
      print: {
        format: 'A4',
        orientation: 'portrait',
        trimBox: { width: C.TRIM_W_MM, height: C.TRIM_H_MM },
        bleedMm: C.BLEED_MM,
        mediaBox: { width: C.MEDIA_W_MM, height: C.MEDIA_H_MM },
        contentBox: { x: C.BLEED_MM, y: C.BLEED_MM, width: C.TRIM_W_MM, height: C.TRIM_H_MM },
        bleedColor: '#ffffff'
      },
      spreads: spreadMemory.map(function (spread, index) {
        return { spreadIndex: index, pageIndexes: [index * 2 + 1, index * 2 + 2] };
      }),
      pages: pages
    };
  }

  root.PictoirelPrintBlueprint = {
    constants: C,
    mapPointToPageMm: mapPointToPageMm,
    objectBoundsPx: objectBoundsPx,
    buildPrintBlueprint: buildPrintBlueprint
  };
})();
